import React, { useState, useEffect } from "react";
import {
    Box, Button, Flex,
    Text, Circle, VStack,
    HStack, Input, Table, Thead, Stack, Spinner, FormErrorMessage, InputGroup, InputRightElement, Textarea,
    Tbody, Tr, Th, Td, IconButton, FormControl, FormLabel, Select, SimpleGrid, useBreakpointValue, useToast
} from "@chakra-ui/react";
import { CheckIcon, AddIcon, MinusIcon, DeleteIcon } from "@chakra-ui/icons";
import { searchProdutosAutoComplete, searchOrcamento, postVendaManual } from "../services/api";
import ProdutoImagem from "../components/ProdutoImagem";

const steps = [
    {
        title: "Produtos",
        description: "Adicione os produtos desejados ao carrinho.",
    },
    {
        title: "Cliente",
        description: "Insira nome, documento e outras informações do cliente.",
    },
    {
        title: "Envio",
        description: "Escolha a forma de envio e insira o endereço.",
    },
    {
        title: "Pagamento",
        description: "Selecione a forma de pagamento e adicione informações adicionais.",
    },
    {
        title: "Resumo",
        description: "Resumo.",
    },
];

const mockProducts = [
    {
        id: 1,
        name: "Trava",
        codigo_global: "2RD311311A",
        fabricante: "EATON",
        preco: "100",
        image: "https://vps.tagaautopartes.com.br/imagens_produtos/007474.jpg", // Exemplo de imagem
    },
    {
        id: 2,
        name: "BUJAO",
        codigo_global: "2RD311467",
        fabricante: "EATON",
        preco: "100",
        image: "https://vps.tagaautopartes.com.br/imagens_produtos/007504.jpg",
    },
    {
        id: 3,
        name: "ALAVANCA MUDANCA INTERNA",
        codigo_global: "2RD311543A",
        fabricante: "EATON",
        preco: "100",
        image: "https://vps.tagaautopartes.com.br/imagens_produtos/007514.jpg",
    },
];


const VendaManual = () => {
    useEffect(() => {
        handleStateChange("SP");
    }, []);

    const toast = useToast()
    const [codigoOrcamento, setCodigoOrcamento] = useState("");
    const [carregandoOrcamento, setCarregandoOrcamento] = useState(false);
    const [isLoadingGerarVenda, setIsLoadingGerarVenda] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [skipNextSearch, setSkipNextSearch] = useState(false);
    const [autocompleteOpen, setAutocompleteOpen] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [cart, setCart] = useState([]);
    const [cities, setCities] = useState([]);
    const [clientData, setClientData] = useState({
        name: "",
        document: "",
        ie: "",
        email: "",
        phone: "",
        address: {
            street: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            state: "",
            zipCode: "",
        },
    });
    const [shippingData, setShippingData] = useState({
        transportadora: "",
        tipo_frete: "",
        valorFrete: "",
        prazoEnvio: "",
        codigoRastreio: "",
        linkRastreio: "",
        observacoes: "",
    });
    const handleShippingDataChange = (field, value) => {
        setShippingData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };
    const [paymentData, setPaymentData] = useState({
        formaPagamento: "",
        observacoes: "",
    });

    const handlePaymentDataChange = (field, value) => {
        setPaymentData((prev) => ({ ...prev, [field]: value }));
    };

    const [desconto, setDesconto] = useState("");
    const [descontoReais, setDescontoReais] = useState("");
    const [subTotalOrcamento, setSubTotalOrcamento] = useState("");
    const [totalOrcamento, setTotalOrcamento] = useState("");

    const handleDescontoChange = (e) => {
        let valor = parseFloat(e.target.value) || 0;

        if (valor > 100) {
            valor = 100;
        }

        if (valor < 0) {
            valor = 0;
        }

        setDesconto(valor);
    };

    const calcularSubtotal = () => {
        return cart && cart.reduce((total, produto) => total + (produto.valor_venda * (produto.quantity || 1)), 0);
    };

    const calcularDesconto = () => {
        return (calcularSubtotal() * desconto) / 100;
    };

    const calcularTotal = () => {
        return calcularSubtotal() - calcularDesconto();
    };

    const formatarPreco = (valor) => {
        const numero = Number(valor); // Converte o valor para número
        if (isNaN(numero) || numero === null) return "0,00"; // Verifica se é um número válido
        return numero.toFixed(2).replace(".", ","); // Formata para 2 casas decimais e substitui ponto por vírgula
    };


    const alteraTotalizadores = () => {
        const subTotal = calcularSubtotal();
        setSubTotalOrcamento(subTotal);

        const descontoValor = calcularDesconto(subTotal);
        setTotalOrcamento(subTotal - descontoValor);

        const descontoReais = calcularDesconto();
        setDescontoReais(descontoReais);
    }

    useEffect(() => {
        alteraTotalizadores();
    }, [cart, desconto]);


    const [documentType, setDocumentType] = useState("CPF");
    const formatDocument = (value, type) => {
        const cleaned = value.replace(/\D/g, "");

        if (type === "CPF") {
            return cleaned
                .replace(/^(\d{3})(\d)/, "$1.$2")
                .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d{0,2})/, "$1.$2.$3-$4")
                .slice(0, 14);
        }

        if (type === "CNPJ") {
            return cleaned
                .replace(/^(\d{2})(\d)/, "$1.$2")
                .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
                .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{0,2})/, "$1.$2.$3/$4-$5")
                .slice(0, 18);
        }

        return value;
    };


    const fetchCitiesByState = async (uf) => {
        if (!uf) return;
        try {
            const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
            const data = await response.json();
            const cityNames = data.map((city) => city.nome);
            setCities(cityNames);
        } catch (error) {
            console.error("Erro ao buscar cidades do IBGE:", error);
            setCities([]);
        }
    };

    const handleStateChange = (state) => {
        handleAddressChange("state", state);
        fetchCitiesByState(state);
        handleAddressChange("city", "");
    };


    const handleClientDataChange = (field, value) => {
        setClientData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    const handleAddressChange = (field, value) => {
        setClientData((prevData) => ({
            ...prevData,
            address: {
                ...prevData.address,
                [field]: value,
            },
        }));
    };

    const handleSetSearchTerm = (value) => {
        setSearchTerm(value);
        setAutocompleteOpen(true);
    }

    const handleSetSearchTermEvent = (value, skip) => {
        setSearchTerm(value);
        setSkipNextSearch(skip)
    }

    const nextStep = () => setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
    const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

    // Filter products for autocomplete
    const [filteredProducts, setFilteredProducts] = useState([]);
    // const filteredProducts = mockProducts.filter((product) =>
    //     product.name.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    useEffect(() => {

        if (skipNextSearch) {
            setSkipNextSearch(false);
            return;
        }
        const fetchProducts = async () => {
            if (!searchTerm) {
                setFilteredProducts([]);
                return;
            }

            try {
                const result = await searchProdutosAutoComplete(searchTerm);
                setFilteredProducts(result);
                setAutocompleteOpen(true);
            } catch (error) {
                console.error("Erro ao buscar produtos:", error);
            }
        };

        const delayDebounce = setTimeout(() => {
            fetchProducts();
        }, 300); // debounce

        return () => clearTimeout(delayDebounce);
    }, [searchTerm]);


    const formatarValorTotal = (valor) => {
        return parseFloat(valor.toFixed(2));
    };

    // Add product to the cart
    const addProductToCart = () => {
        if (selectedProduct && quantity > 0) {
            const existingProduct = cart.find((item) => item.id === selectedProduct.id);
            if (existingProduct) {
                // Update quantity if product already exists in the cart
                setCart((prevCart) =>
                    prevCart.map((item) =>
                        item.id === selectedProduct.id
                            ? {
                                ...item,
                                quantity: item.quantity + quantity,
                                valor_total: formatarValorTotal((item.quantity + quantity) * item.valor_venda), // Update valor_total
                            }
                            : item
                    )
                );
            } else {
                // Add new product to the cart
                setCart((prevCart) => [
                    ...prevCart,
                    {
                        ...selectedProduct,
                        quantity,
                        valor_total: formatarValorTotal(selectedProduct.valor_venda * quantity), // Add valor_total
                    }
                ]);
            }
            // Reset inputs
            setSearchTerm("");
            setSelectedProduct(null);
            setQuantity(1);
        }
        alteraTotalizadores();
    };

    // Increase quantity of a product in the cart
    const increaseQuantity = (id) => {
        setCart((prevCart) =>
            prevCart.map((item) =>
                item.id === id
                    ? {
                        ...item,
                        quantity: item.quantity + 1,
                        valor_total: formatarValorTotal((item.quantity + 1) * item.valor_venda) // Recalculate valor_total
                    }
                    : item
            )
        );
        alteraTotalizadores();
    };

    // Decrease quantity of a product in the cart
    const decreaseQuantity = (id) => {
        setCart((prevCart) =>
            prevCart.map((item) =>
                item.id === id && item.quantity > 1
                    ? {
                        ...item,
                        quantity: item.quantity - 1,
                        valor_total: formatarValorTotal((item.quantity - 1) * item.valor_venda) // Recalculate valor_total
                    }
                    : item
            )
        );
        alteraTotalizadores();
    };

    // Remove product from the cart
    const removeProductFromCart = (id) => {
        setCart((prevCart) => prevCart.filter((item) => item.id !== id));
        alteraTotalizadores();
    };


    const [cepLoading, setCepLoading] = useState(false);
    const [cepError, setCepError] = useState(false);
    const handleCepChange = async (cepRaw) => {
        const formattedCep = formatCep(cepRaw);
        handleAddressChange("zipCode", formattedCep);

        const cleanedCep = cleanCep(formattedCep);
        setCepError(false);

        if (cleanedCep.length === 8) {
            setCepLoading(true);
            try {
                const response = await fetch(`https://viacep.com.br/ws/${cleanedCep}/json/`);
                const data = await response.json();

                if (!data.erro) {
                    handleStateChange(data.uf);
                    handleAddressChange("street", data.logradouro || "");
                    handleAddressChange("neighborhood", data.bairro || "");
                    handleAddressChange("city", data.localidade || "");
                    handleAddressChange("state", data.uf || "");

                } else {
                    setCepError(true); // CEP não encontrado
                    handleAddressChange("street", "");
                    handleAddressChange("neighborhood", "");
                    handleAddressChange("city", "");
                    handleAddressChange("state", "");
                }
            } catch (error) {
                console.error("Erro ao buscar CEP:", error);
                setCepError(true);
            } finally {
                setCepLoading(false);
            }
        } else if (cleanedCep.length > 8) {
            setCepError(true);
        }
    };


    const cleanCep = (value) => value.replace(/\D/g, '');
    const formatCep = (value) => {
        return value
            .replace(/\D/g, '')
            .replace(/^(\d{5})(\d)/, '$1-$2')
            .slice(0, 9);
    };

    const formatPhone = (value) => {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned.length <= 10) {
            return cleaned
                .replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
                .trim();
        }
        return cleaned
            .replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3')
            .trim();
    };
    const cleanPhone = (value) => value.replace(/\D/g, '');
    const formatEmail = (value) => value.trim();

    const inserirOrcamento = async () => {
        if (!codigoOrcamento) return;
        setCarregandoOrcamento(true);

        try {
            const responseOrcamento = await searchOrcamento(codigoOrcamento);

            if (responseOrcamento !== false && responseOrcamento.produtos) {
                console.log("responseOrcamento = ", responseOrcamento);

                // 1. Atualiza os produtos no carrinho
                setCart((prevCart) => {
                    const novosProdutos = responseOrcamento.produtos.filter(
                        (produto) => !prevCart.some((item) => item.id === produto.id)
                    );
                    const produtosParaAdicionar = novosProdutos.map((produto) => ({
                        ...produto,
                        id: produto.id,
                        quantity: produto.quantidade_orcamento,
                        valor_total: formatarValorTotal(produto.valor_venda * produto.quantidade_orcamento),
                    }));

                    return [...prevCart, ...produtosParaAdicionar];
                });

                const clienteInfo = responseOrcamento.dados_cliente;

                if (clienteInfo) {
                    if (clienteInfo.nome) handleClientDataChange("name", clienteInfo.nome);
                    if (clienteInfo.documento) handleClientDataChange("document", formatDocument(clienteInfo.documento, documentType));
                    if (clienteInfo.telefone) handleClientDataChange("phone", formatPhone(clienteInfo.telefone));
                    if (clienteInfo.email) handleClientDataChange("email", formatEmail(clienteInfo.email));

                    if (clienteInfo.observacoes) handlePaymentDataChange("observacoes", clienteInfo.observacoes);
                }

                setTimeout(() => {
                    setCarregandoOrcamento(false);
                }, 1000);

            } else {
                toast({
                    title: `Não foi posssível consultar o orçamento.`,
                    status: 'error',
                    isClosable: true,
                    duration: 1000,
                });
                setTimeout(() => {
                    setCarregandoOrcamento(false);
                }, 1000);
            }
        } catch (err) {
            console.error("Erro ao inserir orçamento", err);
            setTimeout(() => {
                setCarregandoOrcamento(false);
            }, 1000);
        }
    };

    const montarJsonVenda = () => {
        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        return {
            venda: {
                orcamento: codigoOrcamento,
                user_id: user.id,
            },
            produtos: cart.map((item) => ({
                produto_estoque_id: item.id,
                valor_unitario: item.valor_venda,
                quantidade: item.quantity,
            })),
            cliente: {
                nome: clientData.name,
                documento: clientData.document,
                ie: clientData.ie,
                email: clientData.email,
                telefone: clientData.phone,
                tipo: documentType === "CPF" ? 1 : 2,
                endereco: {
                    uf: clientData.address.state,
                    cidade: clientData.address.city,
                    endereco: clientData.address.street,
                    bairro: clientData.address.neighborhood,
                    numero: clientData.address.number,
                    complemento: clientData.address.complement,
                    cep: clientData.address.zipCode
                },
            },
            envio: {
                transportadora: shippingData.transportadora,
                tipo_frete: shippingData.tipo_frete,
                valor_frete: shippingData.valorFrete,
                prazo_envio: shippingData.prazoEnvio,
                codigo_rastreio: shippingData.codigoRastreio,
                link_rastreio: shippingData.linkRastreio,
                observacao: shippingData.observacoes,
            },
            pagamento: {
                forma_pagamento: paymentData.formaPagamento,
                sub_total: subTotalOrcamento,
                desconto: descontoReais,
                total: totalOrcamento,
                observacao: paymentData.observacoes,
            },
        };
    };


    const handleClickGerarVenda = () => {
        setIsLoadingGerarVenda(true);
        handleGerarVenda();
    };

    const handleGerarVenda = () => {
        const json = montarJsonVenda();
        try {
            (async () => {
                const response = await postVendaManual(json);
                console.log("response = ", response)
                if (response.status != false) {
                    toast({
                        title: `Venda cadastrada com sucesso!`,
                        status: 'success',
                        isClosable: true,
                    })

                    const userString = window.localStorage.getItem("user");
                    const user = JSON.parse(userString);
                    setTimeout(() => {
                        if (user.tipo == 2) {
                            window.location.href = '/vendas_vendedor';
                        } else {
                            window.location.href = '/vendas';
                        }
                    }, 2000);

                } else {
                    toast({
                        title: `Erro ao cadastrar venda`,
                        description: response.data.error,
                        status: 'error',
                        isClosable: true,
                    })
                    setTimeout(() => {
                        setIsLoadingGerarVenda(false);
                    }, 2500);
                }
            })();
        }
        catch {
            toast({
                title: `Erro ao cadastrar venda`,
                status: 'error',
                isClosable: true,
            })
            setTimeout(() => {
                setIsLoadingGerarVenda(false);
            }, 1000);
            return false;
        }
    };

    return (
        <Box bg="white" minH="100vh" py={10} px={4}>
            <Text fontSize="xl" fontWeight="bold" textAlign="center" color="orange.500">
                Cadastro de Venda Manual
            </Text>
            <Box maxW="1200px" mx="auto" mt={10}>
                {/* Steps Header */}

                <Flex m="auto" w="100%" justify="center">
                    <Box w="100%" maxW="800px"> {/* ou w="80%", ou w="600px", como preferir */}
                        <HStack
                            justifyContent="space-between"
                            alignItems="center"
                            position="relative"
                            mb={8}
                            w="100%"
                        >
                            {steps.map((step, index) => {
                                if (index === 4) return null;
                                return (
                                    <React.Fragment key={index}>
                                        <VStack spacing={2}>
                                            <Circle
                                                size="40px"
                                                bg={currentStep >= index ? "green.400" : "gray.200"}
                                                color="white"
                                            >
                                                {currentStep > index ? <CheckIcon /> : index + 1}
                                            </Circle>
                                            <Text
                                                fontSize="14px"
                                                fontWeight={currentStep === index ? "bold" : "normal"}
                                                color={currentStep >= index ? "green.600" : "gray.500"}
                                                textAlign="center"
                                            >
                                                {step.title}
                                            </Text>
                                        </VStack>

                                        {index < steps.length - 2 && ( // -2 pq você "pulou" um
                                            <Box
                                                flex="1"
                                                height="2px"
                                                bg={currentStep > index ? "green.400" : "gray.300"}
                                            />
                                        )}
                                    </React.Fragment>
                                );
                            })}

                        </HStack>
                    </Box>
                </Flex>


                {/* Step Content */}
                {currentStep === 0 && (
                    <Box p={6} borderWidth="1px" borderRadius="md">
                        <Text fontSize="lg" fontWeight="bold">
                            Adicionar Produtos ao Carrinho
                        </Text>
                        <Flex mt={8} maxW="400px">
                            <FormControl>
                                <FormLabel>Adicionar Produtos via Orçamento</FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        bg="white"
                                        placeholder="Código do Orçamento"
                                        value={codigoOrcamento}
                                        onChange={(e) => setCodigoOrcamento(e.target.value)}
                                    />
                                    <InputRightElement width="4.5rem">
                                        {carregandoOrcamento ? (
                                            <Spinner size="md" />
                                        ) : (
                                            <Button h="1.75rem" size="md" onClick={inserirOrcamento}>
                                                Inserir
                                            </Button>
                                        )}
                                    </InputRightElement>
                                </InputGroup>
                            </FormControl>
                        </Flex>
                        <Flex mt={4} gap={4} alignItems="center">
                            {/* Imagem do produto selecionado */}
                            {selectedProduct && (
                                <Box boxSize="50px" flexShrink={0}>
                                    <ProdutoImagem
                                        produto={selectedProduct}
                                        origem={""}
                                        width={"50px"}
                                        height={"50px"}
                                    />
                                </Box>
                            )}

                            {/* Autocomplete Input */}
                            <Box flex="2" mt={5}>
                                <Input
                                    placeholder="Pesquisar produto..."
                                    value={searchTerm}
                                    onChange={(e) => handleSetSearchTerm(e.target.value)}
                                />
                                {/* Autocomplete Suggestions */}
                                {autocompleteOpen && searchTerm && filteredProducts.length > 0 && (
                                    <Box bg="white" borderWidth="1px" mt={2} borderRadius="md" maxH="200px" overflowY="auto">
                                        {filteredProducts.map((product) => (
                                            <Flex
                                                key={product.id}
                                                align="center"
                                                gap={3}
                                                p={2}
                                                cursor="pointer"
                                                _hover={{ bg: "gray.100" }}
                                                onClick={() => {
                                                    setSelectedProduct(product);
                                                    handleSetSearchTermEvent(product.nome, true);
                                                    setAutocompleteOpen(false);
                                                }}
                                            >
                                                <Box boxSize="40px" mr={2}>
                                                    <ProdutoImagem
                                                        produto={product}
                                                        origem={""}
                                                        width={"50px"}
                                                        height={"50px"}
                                                    />
                                                </Box>
                                                <Text>{product.nome + " - " + product.codigo_global}</Text>
                                            </Flex>
                                        ))}
                                    </Box>
                                )}
                            </Box>

                            {/* Quantity Input */}
                            <FormControl width="80px">
                                <FormLabel fontSize="xs" mb={1}>Quantidade</FormLabel>
                                <Input
                                    type="number"
                                    placeholder="Qtd"
                                    value={quantity}
                                    onChange={(e) => setQuantity(Number(e.target.value))}
                                />
                            </FormControl>

                            {/* Add Button */}
                            <Button mt={5} colorScheme="orange" onClick={addProductToCart}>
                                Adicionar
                            </Button>
                        </Flex>


                        {/* Products Table */}
                        <Box overflowX="auto">
                            <Table variant="simple" mt={6}>
                                <Thead>
                                    <Tr>
                                        <Th></Th>
                                        <Th>Produto</Th>
                                        <Th>Cod. Global</Th>
                                        <Th>Fabricante</Th>
                                        <Th>Preço Unit.</Th>
                                        <Th>Quantidade</Th>
                                        <Th>Preço</Th>
                                        <Th>Ações</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {cart && cart.map((item) => (
                                        <Tr key={item.id}>
                                            <Td>
                                                <Box boxSize="60px">
                                                    <ProdutoImagem
                                                        produto={item}
                                                        origem={""}
                                                        width={"50px"}
                                                        height={"50px"}
                                                    />
                                                </Box>
                                            </Td>
                                            <Td>{item.nome}</Td>
                                            <Td>{item.codigo_global}</Td>
                                            <Td>{item.fabricante_nome}</Td>
                                            <Td>R${formatarPreco(item.valor_venda)}</Td>
                                            <Td>
                                                <HStack>
                                                    <Text>{item.quantity}</Text>
                                                </HStack>
                                            </Td>
                                            <Td>R${formatarPreco(item.valor_total)}</Td> {/* Preço recalculado */}
                                            <Td>
                                                <HStack spacing={2}>
                                                    <IconButton
                                                        icon={<AddIcon />}
                                                        size="sm"
                                                        onClick={() => increaseQuantity(item.id)}
                                                    />
                                                    <IconButton
                                                        icon={<MinusIcon />}
                                                        size="sm"
                                                        onClick={() => decreaseQuantity(item.id)}
                                                        isDisabled={item.quantity <= 1}
                                                    />
                                                    <IconButton
                                                        icon={<DeleteIcon />}
                                                        size="sm"
                                                        colorScheme="red"
                                                        onClick={() => removeProductFromCart(item.id)}
                                                    />
                                                </HStack>
                                            </Td>
                                        </Tr>
                                    ))}
                                    {/* Linha para subtotal */}
                                    <Tr bg="gray.200">
                                        <Td colSpan={5} textAlign="right"><Text fontWeight="bold">SUBTOTAL</Text></Td>
                                        <Td textAlign="right"><Text fontWeight="bold"></Text></Td>
                                        <Td textAlign="center">
                                            <Text>
                                                R$ {formatarPreco(calcularSubtotal())}
                                            </Text>
                                        </Td>
                                        <Td textAlign="right"><Text fontWeight="bold"></Text></Td>
                                    </Tr>
                                    {/* Linha para aplicar desconto */}
                                    <Tr bg="gray.200">
                                        <Td colSpan={5} textAlign="right"><Text fontWeight="bold">DESCONTO</Text></Td>
                                        <Td textAlign="center">
                                            <Flex flexDirection={"row"} align={"center"} justify={"center"} whiteSpace="nowrap">
                                                <Input
                                                    bg="white"
                                                    max="100"
                                                    value={desconto}
                                                    onChange={handleDescontoChange}
                                                    width="60px"
                                                    textAlign="center"
                                                />
                                                %
                                            </Flex>
                                        </Td>
                                        <Td textAlign="center">
                                            <Text>
                                                R$ -{formatarPreco(calcularDesconto())}
                                            </Text>
                                        </Td>
                                        <Td textAlign="right"><Text fontWeight="bold"></Text></Td>
                                    </Tr>
                                    {/* Linha para o total com desconto aplicado */}
                                    <Tr bg="gray.300">
                                        <Td colSpan={5} textAlign="right"><Text fontWeight="bold">TOTAL</Text></Td>
                                        <Td></Td>
                                        <Td textAlign="center">
                                            <Text fontWeight={"bold"}>
                                                R$ {formatarPreco(calcularTotal())}
                                            </Text>
                                        </Td>
                                        <Td textAlign="right"><Text fontWeight="bold"></Text></Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </Box>
                    </Box>
                )}

                {currentStep === 1 && cart.length > 0 && (
                    <>
                        <Flex w={"90%"} justifyContent={"center"} justify={"center"} flexDirection={"column"} m={"auto"}>
                            {/* Card de Cadastro de Informações do Cliente */}
                            <Box bg={"orange.400"} borderRadius="lg" borderWidth="1px" >
                                <Text fontSize="xl" fontWeight="bold" textAlign="center" color="white">
                                    Informações do Cliente
                                </Text>
                            </Box>
                            <Box p={6} borderWidth="1px" borderRadius="lg" boxShadow="lg" borderColor={"gray.300"} bg="gray.200">
                                <VStack spacing={6} mt={6}>
                                    {/* Nome e Documento */}
                                    <Stack direction={["column", "row"]} w="100%" spacing={6}>
                                        <FormControl isRequired>
                                            <FormLabel>Nome</FormLabel>
                                            <Input
                                                bg="white"
                                                placeholder="Nome completo"
                                                value={clientData.name}
                                                onChange={(e) => handleClientDataChange("name", e.target.value)}
                                            />
                                        </FormControl>
                                        <FormControl isRequired>
                                            <FormLabel>Documento</FormLabel>
                                            <InputGroup>
                                                <Input
                                                    bg="white"
                                                    placeholder={documentType === "CPF" ? "CPF: 000.000.000-00" : "CNPJ: 00.000.000/0001-00"}
                                                    value={clientData.document}
                                                    onChange={(e) =>
                                                        handleClientDataChange("document", formatDocument(e.target.value, documentType))
                                                    }
                                                />
                                                <InputRightElement width="8.5rem" bg={"gray.400"}>
                                                    <Button
                                                        h="1.5rem"
                                                        size="sm"
                                                        variant={documentType === "CPF" ? "solid" : "ghost"}
                                                        onClick={() => setDocumentType("CPF")}
                                                        mr={1}
                                                    >
                                                        CPF
                                                    </Button>
                                                    <Button
                                                        h="1.5rem"
                                                        size="sm"
                                                        variant={documentType === "CNPJ" ? "solid" : "ghost"}
                                                        onClick={() => setDocumentType("CNPJ")}
                                                    >
                                                        CNPJ
                                                    </Button>
                                                </InputRightElement>
                                            </InputGroup>
                                        </FormControl>
                                        {documentType === "CNPJ" && (
                                            <FormControl>
                                                <FormLabel>Inscrição Estadual</FormLabel>
                                                <Input
                                                    bg="white"
                                                    placeholder="IE (Apenas números)"
                                                    value={clientData.ie}
                                                    onChange={(e) => handleClientDataChange("ie", e.target.value.replace(/\D/g, ""))}
                                                />
                                            </FormControl>
                                        )}
                                    </Stack>

                                    {/* Email e Telefone */}
                                    <Stack direction={["column", "row"]} w="100%" spacing={6}>
                                        <FormControl>
                                            <FormLabel>Email</FormLabel>
                                            <Input
                                                bg="white"
                                                type="email"
                                                placeholder="Email"
                                                value={clientData.email}
                                                onChange={(e) => handleClientDataChange("email", formatEmail(e.target.value))}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Telefone</FormLabel>
                                            <Input
                                                bg="white"
                                                type="tel"
                                                placeholder="(99) 99999-9999"
                                                value={clientData.phone}
                                                onChange={(e) => handleClientDataChange("phone", formatPhone(e.target.value))}
                                            />
                                        </FormControl>
                                    </Stack>
                                </VStack>
                            </Box>

                            {/* Card de Endereço */}
                            <Box bg={"orange.400"} borderRadius="lg" borderWidth="1px" >
                                <Text fontSize="xl" fontWeight="bold" textAlign="center" color="white">
                                    Endereço
                                </Text>
                            </Box>
                            <Box p={6} borderWidth="1px" borderRadius="lg" boxShadow="lg" borderColor={"gray.300"} bg="gray.200" >
                                {/* CEP */}
                                <FormControl isRequired w="100%" isInvalid={cepError}>
                                    <FormLabel>CEP</FormLabel>
                                    <Input
                                        bg={"white"}
                                        placeholder="Digite o CEP (ex: 36180-000)"
                                        value={clientData.address.zipCode}
                                        onChange={(e) => handleCepChange(e.target.value)}
                                        w={"250px"}
                                    />
                                    <Text fontSize="sm" color="gray.500" mt={1}>
                                        Ao preencher o CEP corretamente, os campos de endereço serão preenchidos automaticamente.
                                    </Text>

                                    {cepLoading && (
                                        <Text fontSize="sm" color="blue.500" mt={1}>
                                            Buscando dados do endereço...
                                        </Text>
                                    )}

                                    {cleanCep(clientData.address.zipCode).length < 8 && (
                                        <Text fontSize="sm" color="orange.500" mt={1}>
                                            Faltam {8 - cleanCep(clientData.address.zipCode).length} caractere(s) para buscar o endereço.
                                        </Text>
                                    )}

                                    {cepError && cleanCep(clientData.address.zipCode).length === 8 && (
                                        <FormErrorMessage>CEP não encontrado. Verifique se foi digitado corretamente.</FormErrorMessage>
                                    )}
                                </FormControl>

                                {/* Bairro, Cidade e Estado */}
                                <Stack direction={["column", "row"]} w="100%" spacing={6} mt={2}>
                                    <FormControl isRequired>
                                        <FormLabel>Bairro</FormLabel>
                                        <Flex align="center">
                                            <Input
                                                bg={"white"}
                                                placeholder="Bairro"
                                                value={clientData.address.neighborhood}
                                                onChange={(e) => handleAddressChange("neighborhood", e.target.value)}
                                                isDisabled={cepLoading}
                                            />
                                            {cepLoading && <Spinner ml={2} size="sm" />}
                                        </Flex>
                                    </FormControl>
                                    <FormControl isRequired>
                                        <FormLabel>Cidade</FormLabel>
                                        <Select
                                            bg={"white"}
                                            placeholder="Selecione a cidade"
                                            value={clientData.address.city}
                                            onChange={(e) => handleAddressChange("city", e.target.value)}
                                            isDisabled={cities.length === 0}
                                        >
                                            {cities.map((city) => (
                                                <option key={city} value={city}>
                                                    {city}
                                                </option>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl isRequired>
                                        <FormLabel>Estado</FormLabel>
                                        <Flex align="center">
                                            <Select
                                                bg={"white"}
                                                placeholder="UF"
                                                value={clientData.address.state}
                                                onChange={(e) => handleStateChange(e.target.value)}
                                                isDisabled={cepLoading}
                                            >
                                                {["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"].map((uf) => (
                                                    <option key={uf} value={uf}>{uf}</option>
                                                ))}
                                            </Select>
                                            {cepLoading && <Spinner ml={2} size="sm" />}
                                        </Flex>
                                    </FormControl>
                                </Stack>

                                {/* Rua e Número */}
                                <Stack direction={["column", "row"]} w="100%" spacing={6} mt={2}>
                                    <FormControl isRequired flex={1}>
                                        <FormLabel>Rua</FormLabel>
                                        <Flex align="center">
                                            <Input
                                                bg={"white"}
                                                placeholder="Rua"
                                                value={clientData.address.street}
                                                onChange={(e) => handleAddressChange("street", e.target.value)}
                                                isDisabled={cepLoading}
                                            />
                                            {cepLoading && <Spinner ml={2} size="sm" />}
                                        </Flex>
                                    </FormControl>
                                    <FormControl isRequired w={["100%", "30%"]}>
                                        <FormLabel>Número</FormLabel>
                                        <Input
                                            bg={"white"}
                                            placeholder="Número"
                                            value={clientData.address.number}
                                            onChange={(e) => handleAddressChange("number", e.target.value)}
                                        />
                                    </FormControl>
                                </Stack>

                                <FormControl flex={1} mt={2}>
                                    <FormLabel>Complemento</FormLabel>
                                    <Flex align="center">
                                        <Input
                                            bg={"white"}
                                            placeholder="Complemento"
                                            value={clientData.address.complement}
                                            onChange={(e) => handleAddressChange("complement", e.target.value)}
                                            isDisabled={cepLoading}
                                        />
                                    </Flex>
                                </FormControl>
                            </Box>
                        </Flex>
                    </>
                )}


                {currentStep === 2 && (
                    <>
                        <Flex w={"90%"} justifyContent={"center"} justify={"center"} flexDirection={"column"} m={"auto"}>
                            <Box bg={"orange.400"} borderRadius="lg" borderWidth="1px" >
                                <Text fontSize="xl" fontWeight="bold" textAlign="center" color="white">
                                    Dados de Envio
                                </Text>
                            </Box>
                            <Box p={6} borderWidth="1px" borderRadius="lg" boxShadow="lg" borderColor={"gray.300"} bg="gray.200">
                                <VStack spacing={6} mt={6}>
                                    <Stack direction={["column", "row"]} w="100%" spacing={6}>
                                        <FormControl>
                                            <FormLabel>Transportadora</FormLabel>
                                            <Input
                                                bg="white"
                                                placeholder="CORREIOS"
                                                value={shippingData.transportadora}
                                                onChange={(e) => handleShippingDataChange("transportadora", e.target.value)}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Tipo Frete</FormLabel>
                                            <Input
                                                bg="white"
                                                placeholder="PAC, SEDEX"
                                                value={shippingData.tipo_frete}
                                                onChange={(e) => handleShippingDataChange("tipo_frete", e.target.value)}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Valor do Frete (R$)</FormLabel>
                                            <Input
                                                bg="white"
                                                placeholder="Ex: 25,90"
                                                value={shippingData.valorFrete}
                                                onChange={(e) => {
                                                    let value = e.target.value
                                                        .replace(/[^0-9,]/g, '')         // Permite apenas números e vírgula
                                                        .replace(/(,.*),/g, '$1');       // Impede mais de uma vírgula

                                                    // Se existir vírgula, limita a duas casas decimais
                                                    const parts = value.split(',');
                                                    if (parts.length === 2) {
                                                        parts[1] = parts[1].slice(0, 2); // Limita a 2 dígitos após a vírgula
                                                        value = `${parts[0]},${parts[1]}`;
                                                    }

                                                    handleShippingDataChange("valorFrete", value);
                                                }}
                                            />
                                        </FormControl>
                                    </Stack>

                                    <Stack direction={["column", "row"]} w="100%" spacing={6}>
                                        <FormControl>
                                            <FormLabel>Prazo de Envio (dias úteis)</FormLabel>
                                            <Input
                                                bg="white"
                                                placeholder="Ex: 5"
                                                value={shippingData.prazoEnvio}
                                                onChange={(e) => handleShippingDataChange("prazoEnvio", e.target.value)}
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Código de Rastreio</FormLabel>
                                            <Input
                                                bg="white"
                                                placeholder="Ex: BR123456789SP"
                                                value={shippingData.codigoRastreio}
                                                onChange={(e) => handleShippingDataChange("codigoRastreio", e.target.value)}
                                            />
                                        </FormControl>
                                    </Stack>

                                    <Stack direction={["column", "row"]} w="100%" spacing={6}>
                                        <FormControl>
                                            <FormLabel>Link de Rastreio</FormLabel>
                                            <Input
                                                bg="white"
                                                placeholder="https://exemplo.com/rastreio"
                                                value={shippingData.linkRastreio}
                                                onChange={(e) => handleShippingDataChange("linkRastreio", e.target.value)}
                                            />
                                        </FormControl>
                                    </Stack>

                                    <FormControl w="100%">
                                        <FormLabel>Observações</FormLabel>
                                        <Textarea
                                            bg="white"
                                            placeholder="Informações adicionais sobre o envio..."
                                            value={shippingData.observacoes}
                                            onChange={(e) => handleShippingDataChange("observacoes", e.target.value)}
                                        />
                                    </FormControl>
                                </VStack>

                            </Box>
                        </Flex>
                    </>
                )}

                {currentStep === 3 && (
                    <Flex w={"90%"} justifyContent={"center"} flexDirection={"column"} m={"auto"}>
                        <Box bg={"orange.400"} borderRadius="lg" borderWidth="1px">
                            <Text fontSize="xl" fontWeight="bold" textAlign="center" color="white">
                                Dados de Pagamento
                            </Text>
                        </Box>
                        <Box
                            p={6}
                            borderWidth="1px"
                            borderRadius="lg"
                            boxShadow="lg"
                            borderColor={"gray.300"}
                            bg="gray.200"
                        >
                            <VStack spacing={6} mt={6}>
                                <FormControl w="100%">
                                    <FormLabel>Forma de Pagamento</FormLabel>
                                    <Select
                                        bg="white"
                                        placeholder="Selecione a forma de pagamento"
                                        value={paymentData.formaPagamento}
                                        onChange={(e) => handlePaymentDataChange("formaPagamento", e.target.value)}
                                    >
                                        <option value="boleto">Boleto</option>
                                        <option value="pix">Pix</option>
                                        <option value="cartao_credito">Cartão de Crédito</option>
                                        <option value="cartao_debito">Cartão de Débito</option>
                                        <option value="transferencia">Transferência Bancária</option>
                                        <option value="dinheiro">Dinheiro</option>
                                    </Select>
                                </FormControl>
                                <FormControl w="100%">
                                    <FormLabel>Observações</FormLabel>
                                    <Textarea
                                        bg="white"
                                        placeholder="Informações adicionais sobre o pagamento..."
                                        value={paymentData.observacoes}
                                        onChange={(e) => handlePaymentDataChange("observacoes", e.target.value)}
                                    />
                                </FormControl>
                            </VStack>
                        </Box>
                    </Flex>
                )}

                {currentStep === 4 && (
                    <Flex w="90%" justifyContent="center" flexDirection="column" m="auto">
                        <Box bg={"orange.400"} borderRadius="lg" borderWidth="1px">
                            <Text fontSize="xl" fontWeight="bold" textAlign="center" color="white">
                                Revisão do Pedido
                            </Text>
                        </Box>
                        <Box
                            p={4}
                            borderWidth="1px"
                            borderRadius="lg"
                            boxShadow="lg"
                            borderColor="gray.300"
                            bg="gray.100"
                        >
                            <VStack spacing={4} align="start">
                                {/* BLOCO 1: Cliente + Endereço */}
                                <Box w="100%" p={4} bg="white" borderRadius="md" borderWidth="1px">
                                    <Flex justify="space-between" direction={["column", "row"]}>
                                        {/* Cliente */}
                                        <Box flex="1" pr={[0, 4]} mb={[4, 0]} flexWrap="wrap" wordBreak="break-word">
                                            <Text fontSize="sm" fontWeight="bold" mb={2} color="teal.600">
                                                Cliente
                                            </Text>
                                            <Text fontSize="xs"><b>Nome:</b> {clientData.name}</Text>
                                            <Text fontSize="xs"><b>CPF/CNPJ:</b> {clientData.document}</Text>
                                            <Text fontSize="xs"><b>Telefone:</b> {clientData.phone}</Text>
                                            <Text fontSize="xs"><b>Email:</b> {clientData.email}</Text>
                                        </Box>

                                        {/* Endereço */}
                                        <Box flex="1" pl={[0, 4]} flexWrap="wrap" wordBreak="break-word">
                                            <Text fontSize="sm" fontWeight="bold" mb={2} color="blue.600">
                                                Endereço
                                            </Text>
                                            <Text fontSize="xs"><b>UF:</b> {clientData.address.state}</Text>
                                            <Text fontSize="xs"><b>Endereço:</b> {clientData.address.street}</Text>
                                            <Text fontSize="xs"><b>Número:</b> {clientData.address.number}</Text>
                                            <Text fontSize="xs"><b>Complemento:</b> {clientData.address.complement}</Text>
                                            <Text fontSize="xs"><b>Bairro:</b> {clientData.address.neighborhood}</Text>
                                            <Text fontSize="xs"><b>Cidade:</b> {clientData.address.city}</Text>
                                            <Text fontSize="xs"><b>CEP:</b> {clientData.address.zipCode}</Text>
                                        </Box>
                                    </Flex>
                                </Box>

                                {/* BLOCO 2: Envio + Pagamento */}
                                <Box w="100%" p={4} bg="white" borderRadius="md" borderWidth="1px">
                                    <Flex justify="space-between" direction={["column", "row"]}>
                                        {/* Envio */}
                                        <Box flex="1" pr={[0, 4]} mb={[4, 0]} flexWrap="wrap" wordBreak="break-word">
                                            <Text fontSize="sm" fontWeight="bold" mb={2} color="orange.600">
                                                Envio
                                            </Text>
                                            <Text fontSize="xs"><b>Transportadora:</b> {shippingData.transportadora}</Text>
                                            <Text fontSize="xs"><b>Valor Frete:</b> R$ {shippingData.valorFrete}</Text>
                                            <Text fontSize="xs"><b>Prazo Envio:</b> {shippingData.prazoEnvio} dias</Text>
                                            <Text fontSize="xs"><b>Código Rastreio:</b> {shippingData.codigoRastreio}</Text>
                                            <Text fontSize="xs"><b>Link Rastreio:</b> {shippingData.linkRastreio}</Text>
                                            <Text fontSize="xs"><b>Observações:</b> {shippingData.observacoes}</Text>
                                        </Box>

                                        {/* Pagamento */}
                                        <Box flex="1" pl={[0, 4]} flexWrap="wrap" wordBreak="break-word">
                                            <Text fontSize="sm" fontWeight="bold" mb={2} color="purple.600">
                                                Pagamento
                                            </Text>
                                            <Text fontSize="xs"><b>Forma Pagamento:</b> {paymentData.formaPagamento}</Text>
                                            <Text fontSize="xs"><b>Subtotal:</b> R$ {formatarPreco(subTotalOrcamento)}</Text>
                                            <Text fontSize="xs"><b>Desconto:</b> R$ {formatarPreco(descontoReais)}</Text>
                                            <Text fontSize="xs"><b>Valor Total:</b> R$ {formatarPreco(totalOrcamento)}</Text>
                                            <Text fontSize="xs"><b>Observações:</b> {paymentData.observacoes}</Text>
                                        </Box>
                                    </Flex>
                                </Box>

                                <Box w="100%" p={4} bg="white" borderRadius="md" borderWidth="1px">
                                    <Text fontSize="sm" fontWeight="bold" mb={2} color="green.600">
                                        Produtos
                                    </Text>

                                    <Box overflowX="auto">
                                        <Table size="sm" variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th>Nome</Th>
                                                    <Th>Código</Th>
                                                    <Th>Fabricante</Th>
                                                    <Th isNumeric>Valor Unitário</Th>
                                                    <Th isNumeric>Quantidade</Th>
                                                    <Th isNumeric>Total</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {cart && cart.map((item) => (
                                                    <Tr key={item.id}>
                                                        <Td>{item.nome}</Td>
                                                        <Td>{item.codigo_global}</Td>
                                                        <Td>{item.fabricante_nome}</Td>
                                                        <Td isNumeric>R$ {item.valor_venda.toFixed(2)}</Td>
                                                        <Td isNumeric>{item.quantity}</Td>
                                                        <Td isNumeric>R$ {formatarPreco((item.valor_venda * item.quantity))}</Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </Box>
                                </Box>

                            </VStack>
                        </Box>
                    </Flex>
                )}





                {/* Navigation Buttons */}
                <Flex justifyContent="space-between" mt={6}>
                    <Button onClick={prevStep} isDisabled={currentStep === 0}>
                        Voltar
                    </Button>
                    {currentStep < steps.length - 1 ? (
                        <Button
                            colorScheme="orange"
                            onClick={() => {
                                if (currentStep === 0 && cart.length === 0) {
                                    toast({
                                        title: 'Erro',
                                        description: 'Adicione produtos no carrinho antes de continuar.',
                                        status: 'error',
                                        isClosable: true,
                                        duration: 2000,
                                    });
                                    return;
                                }

                                // endereco: {
                                //     uf: clientData.address.state,
                                //     cidade: clientData.address.city,
                                //     endereco: clientData.address.street,
                                //     bairro: clientData.address.neighborhood,
                                //     numero: clientData.address.number,
                                //     complemento: clientData.address.complement,
                                // },

                                console.log("address = ", clientData.address)
                                if (currentStep === 1) {
                                    if (clientData.name.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'Nome do Cliente não informado.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    if (clientData.document.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'Documento do Cliente não informado.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    if (clientData.address.zipCode.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'CEP do Cliente não informado.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    if (clientData.address.neighborhood.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'Bairro do Cliente não informado.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    if (clientData.address.city.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'Cidade do Cliente não informada.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    if (clientData.address.state.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'Estado do Cliente não informado.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    if (clientData.address.street.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'Rua do Cliente não informada.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }
                                    if (clientData.address.number.length == 0) {
                                        toast({
                                            title: 'Erro',
                                            description: 'Número do endereço do Cliente não informado.',
                                            status: 'error',
                                            isClosable: true,
                                            duration: 2000,
                                        });
                                        return;
                                    }

                                }
                                nextStep();
                            }}
                        >
                            Próximo
                        </Button>
                    ) : (
                        <Button
                            colorScheme="green"
                            mr={3}
                            onClick={handleClickGerarVenda}
                            isLoading={isLoadingGerarVenda}
                            loadingText="Processando..."
                            disabled={isLoadingGerarVenda}
                        >
                            {isLoadingGerarVenda ? (
                                <Spinner size="sm" />
                            ) : (
                                'Finalizar'
                            )}
                        </Button>
                    )}
                </Flex>
            </Box>
        </Box>
    );
};

export default VendaManual;
